import { getRequest } from "../../../services/RestServices";
import * as urls from "../../api/scheduler/url";
export const getReport = async (reportType) => {
  try {
    return await getRequest(urls.GET_REPORT + `?reportType=${reportType}`);
  } catch (err) {
    return err;
  }
};
